module.exports = __webpack_public_path__ + "img/elena.25311302.png";